import {useFormikContext} from 'formik';
import {useSelector} from 'react-redux';
import LoginButton from '../loginButton/LoginButton';

function EnterButton({text, actionName,buttonType, disabled, errorText}) {
    const {submitForm} = useFormikContext();
    const XHR = useSelector((state) => state.user?.[`${actionName}XHR`]);
    
    // Disable button if current action is loading or if explicitly disabled
    const isDisabled = disabled || XHR === 'LOADING';

    const onClick = () => {
        if(isDisabled) {
            return;
        }
        submitForm();
    };
    
    return (
        <LoginButton 
            disabled={isDisabled} 
            onClick={onClick} 
            className={XHR} 
            text={text} 
            buttonType={buttonType} 
            errorText={errorText} 
        />
    );
}

export default EnterButton;
